import React from 'react';
import { useSelector } from 'react-redux';

import { useRouter } from '@/hooks/useRouter';
import { getCampgroundListingData } from '@/redux/selectors/campgrounds/page';
import { getAllReviewsHeaderTitle } from '@/redux/selectors/listing/reviews';

import AllReviewsHeader from './AllReviewsHeader';

interface IProps {
  className?: string;
  isCampsite?: boolean;
  isStay?: boolean;
  isCampground?: boolean;
  isAuto?: boolean;
}

const AllReviewsHeaderContainer: React.FC<IProps> = ({
  className,
  isStay,
  isCampground,
  isCampsite,
  isAuto,
}) => {
  const campground = useSelector(getCampgroundListingData);
  let title = useSelector(getAllReviewsHeaderTitle);

  const { query } = useRouter();

  let urlPrefix = '/rv-rental/';
  if (isCampground) urlPrefix = '/campground-rental/';
  if (isCampsite) urlPrefix = '/campsite-rental/';
  if (isStay) urlPrefix = '/stay-rental/';
  if (isAuto) urlPrefix = '/auto/car-rental/';

  let href = `${urlPrefix}${query.location}/${query.slug}?quote=${query.quote}${
    query.step ? `&step=${query.step}` : ''
  }`;

  if (isCampground && campground) {
    title = campground.name;
    href = `${urlPrefix}${query.location}/${query.slug}`;
  }
  return <AllReviewsHeader className={className} title={title} href={href} />;
};

export default AllReviewsHeaderContainer;
